import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import DescriptionIcon from "@mui/icons-material/Description";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { Link } from "react-router-dom";
import { APP_ROUTES, MAIN_ROUTES } from "../../../../_config/routes";

const InfoClientModal = (props) => { 
    return (
        props.clients?
         <TableInfo
            clients = {props.clients}
         />
        :
         'No hay clientes para mostrar...'   
    );
}

const TableInfo = (props) => {
    return (
      <TableContainer component={Paper} elevation={3} style={{ maxHeight: "400px", overflowY: "auto" }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>NOMBRE DE CLIENTE</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {props.clients?.map((client, index) => (
            <TableRow key={index}>
                <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", margin: "0px -5px" }}>
                    <span>{client.name}</span>
                    <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                        <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.clients}`}>
                            <AttachMoneyIcon style={{ marginLeft: "8px" }} />
                        </Link>
                        <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.client_orders}/${client.uuid}`}>
                            <DescriptionIcon style={{ marginLeft: "8px" }} />
                        </Link>
                    </div>
                </div>
                </TableCell>
            </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };
export default InfoClientModal;
